import React from "react";
import {Route, Switch} from "react-router-dom";
import AppliedRoute from "./components/AppliedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import RedirectToPlatform from "./components/RedirectToPlatform";

import Home from "./containers/Home";
import NotFound from "./containers/NotFound";

export default ({childProps}) =>
    <Switch>
        <AppliedRoute path="/" exact component={Home} props={childProps}/>

        <UnauthenticatedRoute path="/redirect" exact component={RedirectToPlatform} props={childProps}/>
        {/* Finally, catch all unmatched routes */}
        <Route component={NotFound}/>
    </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js